import { requiredFieldValidations } from '../../../validations/common/reduxFormValidation';

const associatedValidations = [requiredFieldValidations(['end'])];

const endTimeRequired = { associatedValidations };

export default endTimeRequired;
